import { debounce, isEqual } from 'lodash';
import { useEffect, useRef, useState } from 'react';

const useDebounceWithLoading = <T>(value: T, delay = 500, options?: { leading: boolean; trailing: boolean }) => {
  const [debounced, setDebounced] = useState(value);
  const [isLoading, setIsLoading] = useState(false);
  const previousValue = useRef(value);

  useEffect(() => {
    // 객체의 실제 내용이 이전과 다르면 로딩 상태 시작
    if (!isEqual(previousValue.current, value)) {
      setIsLoading(true);
      previousValue.current = value;
    }

    const handler = debounce(
      () => {
        setDebounced(value);
        setIsLoading(false);
      },
      delay,
      options
    );

    handler();

    return () => {
      handler.cancel();
    };
  }, [value, delay, options]);

  return {
    debouncedValue: debounced,
    isLoading,
  };
};

export default useDebounceWithLoading;
